import React from "react";
import { Link } from "react-router-dom";

import { Button } from "../../../components/ui/button";
import { formatExtraSections } from "../../../handlers/utilityFunctions";

function GenerateResumePopup({
	resume,
	resumeGenerateSpinner,
	createResumeDownload,
	showMessage,
	resultMessage,
	extrasSections,
	handleCheck,
}) {
	return (
		<div className="px-3">
			<div className="mb-3">
				We recommend including only the most relevant sections. You can choose what to leave out below (your info
				won&apos;t be deleted-just excluded from this version).
			</div>

			<h4 className="mb-2 font-bold">Choose sections to exclude:</h4>

			<table>
				<tbody>
					{extrasSections.map((section, i) => (
						<tr className="mb-2" key={i}>
							{/* <div className="checkbox checkbox-circle checkbox-color-scheme"> */}
							<label className="checkbox-checked">
								<input type="checkbox" id={section} onChange={() => handleCheck(section)} value={section} />
								<span className="label-text"> {formatExtraSections(section)}</span>
							</label>
							{/* </div> */}
						</tr>
					))}
				</tbody>
			</table>
			<br />
			{resumeGenerateSpinner ? (
				<div className="col-lg-12 text-right text-lg-center col-7 mb-3">
					<div className="spinner-border" id="generate-spinner" role="status">
						<span className="sr-only">Loading</span>
					</div>{" "}
				</div>
			) : (
				<Button
					type="button"
					id="create-resume"
					className="bg-primary rounded-none mb-3 w-full"
					onClick={() => createResumeDownload(resume.id)}
				>
					Generate Updated PDF Now
				</Button>
			)}
			<label
				style={{
					display: showMessage ? "block" : "none",
					color: "red",
				}}
				id="result-message"
			>
				{resultMessage}
			</label>
			<Link
				style={{
					display: showMessage ? "block" : "none",
				}}
				to="/payments"
				// className="btn btn-primary ml-2"
			>
				Go to subscriptions
			</Link>
		</div>
	);
}

export default GenerateResumePopup;
